import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { tokens } from "../../public/tokens.js";

export const SubjectSideCard = styled.div.withConfig({
  shouldForwardProp: (prop) => !["active", "disabled"].includes(prop),
})`
  border-radius: ${tokens.globals["border-radius"]};
  overflow: hidden;
  padding: 10px;
  border: 1px solid ${tokens.colors.surfaces["border-divider"]};
  background: ${tokens.colors.surfaces["container-background"]};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  min-height: 80px;
  position: relative;
  z-index: 2;

  & + & {
    margin-top: 15px;
    margin-bottom: 15px;
  }

  h3 {
    font-size: ${tokens.typography.fontSize["lg-14px"]};
    font-weight: ${tokens.typography.fontWeights.semibold};
    line-height: 16px;
    margin: 0 0 10px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  ${({ active }) =>
    active &&
    css`
      border: 1px solid ${tokens.colors.theme["highlight-color"]};
      background: ${tokens.colors.theme["hover-color"]};
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.3;

      a {
        cursor: not-allowed;
        pointer-events: none;
      }
    `}

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        border: 1px solid ${tokens.colors.theme["highlight-color"]};
        background:  ${tokens.colors.theme["hover-color"]};
      }

      &:active,
      &:focus {
        background: ${tokens.colors.theme["active-color"]};
        box-shadow: none;
        outline: none;
      }
    `}
`;

export const SubjectCardLink = styled(Link)`
  position: absolute;
  inset: 0;
  z-index: 1;
`;

export const SubjectCardSpan = styled.span`
  position: absolute;
  inset: 0;
  z-index: 1;
`;